module.exports = __webpack_public_path__ + "static/media/Sale.0cbb3630.png";